import { StyleSheet } from "aphrodite/no-important";
import { colour } from "../style/base-theme";

export const styles = StyleSheet.create({
  disc: {
    //display: 'inline-block',
    background: "#fff",
    padding: "15px 0",
    borderRadius: 500,
    display: "inline-flex",
    alignItems: "center",
    justifyContent: "center",
    height: 80,
    width: 80,
    boxShadow: "0 1px 2px rgba(0, 0, 0, 0.1)",
    position: "relative",
    textAlign: "center"
  },
  discSelectable: {
    cursor: "pointer"
  },
  small: {
    width: 50,
    height: 50,
    padding: 15,
    border: `1px solid ${colour.grey[600]}`
  },
  noDisc: {
    width: 50,
    boxShadow: 0
  },
  innerDisc: {
    position: "absolute",
    left: 4,
    top: 4,
    bottom: 4,
    width: "calc(100% - 8px)",
    height: "calc(100% - 8px)",
    borderRadius: 500
  },
  home: {
    background: colour.brand.green
  },
  parentsHome: {
    background: colour.brand.blue
  },
  on: {
    background: colour.brand.green
  },
  selected: {
    background: colour.brand.blue
  },
  center: {
    position: "absolute",
    left: 6,
    top: 6,
    bottom: 6,
    width: "calc(100% - 12px)",
    height: "calc(100% - 12px)",
    borderRadius: 500,
    background: "#fff"
  },
  icon: {
    position: "relative",
    width: 20
  },
  iconLarge: {
    width: 45
  },
  title: {
    display: "none"
  }
});
